import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Form, Checkbox, Row, Col, Icon, DatePicker, Radio} from 'antd';
import moment from 'moment';
import BillModelData from '../ModelData';

const { documentType, role, status } = BillModelData;

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const css = require('./index.scss');

/** 全局数据片段数据接口 */
interface IReduxStatePart {
    
}

/** 组建的props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    // 更新日期
    public startValue: any;
    public endValue: any;
    // 填报时间
    public issuestartValue: any;
    public issueendValue: any;

    /** 构造函数 */
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount(){
        this.issuestartValue = moment(this.modulesState.filterList.issueDateBegin, `YYYY/MM/DD`);
        this.issueendValue = moment(this.modulesState.filterList.issueDateEnd, `YYYY/MM/DD`);
        this.startValue = moment(this.modulesState.filterList.lastModifyTimeBegin, `YYYY/MM/DD`);
        this.endValue = moment(this.modulesState.filterList.lastModifyTimeEnd, `YYYY/MM/DD`);
    }
    render() {
        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator } = form;
        const filterList = this.modulesState.filterList;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 22, offset: 2},
            },
        };
        const dateFormat = this.modulesState.dateFormat;
        const searchActive = this.modulesState.searchActive;
        
        return (
            <div className={css.searchDetail}>
                <div>
                    <Form className="form" onSubmit={this.handleSubmit}>
                        <div style={{marginBottom: '160px'}}>
                            <div className={this.getItemClass('role')}  onClick={() => ModulesAction.changeSateItem('role')}>
                                <span className={css.name}>交易角色</span>
                                <Icon type="shaixuanzhankai" className={css.img}/>
                            </div>
                            <FormItem
                                {...formItemLayout}
                                className={searchActive === 'role' ? '' : 'hide'}
                            >
                                {getFieldDecorator('role', {
                                    initialValue: filterList.role,
                                    rules: [],
                                })(
                                    <Checkbox.Group style={{ width: '100%' }}>
                                        <Row>
                                            <Col span={6}><Checkbox value="Buyer">采购</Checkbox></Col>
                                            <Col span={6}><Checkbox value="Seller">销售</Checkbox></Col>
                                        </Row>
                                    </Checkbox.Group>
                                )}
                            </FormItem>
                            <div className={this.getItemClass('documentType')} onClick={() => ModulesAction.changeSateItem('documentType')}>
                                <span className={css.name}>单据类型</span>
                                <Icon type="shaixuanzhankai" className={css.img} />
                            </div>
                            <FormItem
                                {...formItemLayout}
                                className={searchActive === 'documentType' ? '' : 'hide'}
                            >
                                {getFieldDecorator('documentType', {
                                    initialValue: filterList.documentType,
                                    rules: [],
                                })(
                                    <Checkbox.Group style={{ width: '100%' }} >
                                        <Row>
                                            <Col span={6}><Checkbox value="ForecastPrediction">预测计划</Checkbox></Col>
                                            <Col span={6}><Checkbox value="ForecastDemand">要货计划</Checkbox></Col>
                                            <Col span={6}><Checkbox value="Order">订单</Checkbox></Col>
                                            <Col span={6}><Checkbox value="DespatchAdvice">发货单</Checkbox></Col>
                                            <Col span={6}><Checkbox value="ReceiptAdvice">收货单</Checkbox></Col>
                                            <Col span={6}><Checkbox value="ReceiptAdviceRATC01">冲销入库单</Checkbox></Col>
                                            <Col span={6}><Checkbox value="ReceiptAdviceReturn">退货通知单</Checkbox></Col>
                                            <Col span={6}><Checkbox value="StockInNotice">入库通知单</Checkbox></Col>
                                            <Col span={6}><Checkbox value="Contract">合同</Checkbox></Col>
                                            {/* <Col span={6}><Checkbox value="Reconciliation">对账单</Checkbox></Col> */}

                                            <Col span={6}><Checkbox value="Invoice">发票</Checkbox></Col>
                                        </Row>
                                    </Checkbox.Group>
                                )}
                            </FormItem>
                            <div className={this.getItemClass('status')} onClick={() => ModulesAction.changeSateItem('status')}>
                                <span className={css.name}>文档状态</span>
                                <Icon type="shaixuanzhankai" className={css.img} />
                            </div>
                            <FormItem
                                {...formItemLayout}
                                className={searchActive === 'status' ? '' : 'hide'}
                            >
                                {getFieldDecorator('status', {
                                    initialValue: filterList.status,
                                    rules: [],
                                })(
                                    <Checkbox.Group style={{ width: '100%' }} >
                                        <Row>
                                            <Col span={6}><Checkbox value="DRAFT">草稿</Checkbox></Col>
                                            <Col span={6}><Checkbox value="SENT">已发送</Checkbox></Col>
                                            <Col span={6}><Checkbox value="RECEIVED">已接收</Checkbox></Col>
                                            <Col span={6}><Checkbox value="ACCEPTED">已接受</Checkbox></Col>
                                            <Col span={6}><Checkbox value="REJECTED">已拒绝</Checkbox></Col>
                                            <Col span={6}><Checkbox value="CANCEL_REQUESTING">申请作废</Checkbox></Col>
                                            <Col span={6}><Checkbox value="CANCEL_REJECTED">拒绝作废</Checkbox></Col>
                                            <Col span={6}><Checkbox value="CANCELED">已作废</Checkbox></Col>
                                            <Col span={6}><Checkbox value="ISSUED">已开具</Checkbox></Col>
                                        </Row>
                                    </Checkbox.Group>
                                )}
                            </FormItem>
                            <div className={this.getItemClass('setTime')} onClick={() => ModulesAction.changeSateItem('setTime')}>
                                <span className={css.name}>填报时间</span>
                                <Icon type="shaixuanzhankai" className={css.img} />
                            </div>
                            <FormItem
                                {...formItemLayout}
                                className={searchActive === 'setTime' ? '' : 'hide'}
                            >
                                <Col span={10}>
                                    <FormItem>
                                        {getFieldDecorator('issueDateBegin', {
                                            initialValue: filterList.issueDateBegin && moment(filterList.issueDateBegin, dateFormat)
                                        })(
                                            <DatePicker 
                                                style={{ width: '100%' }} 
                                                format={dateFormat}
                                                disabledDate={this.issuedisabledStartDate}
                                                onChange={this.issueonStartChange} 
                                            />
                                        )}
                                    </FormItem>
                                </Col>
   
                                <Col span={2}>
                                    <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                        至
                                    </span>
                                </Col>
                                <Col span={10}>
                                    <FormItem>
                                        {getFieldDecorator('issueDateEnd', {
                                            initialValue: filterList.issueDateEnd && moment(filterList.issueDateEnd, dateFormat)
                                        })(
                                            <DatePicker 
                                                style={{ width: '100%' }} 
                                                format={dateFormat}
                                                disabledDate={this.issuedisabledEndDate}
                                                onChange={this.issueonEndChange}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                            <div className={this.getItemClass('updateTime')}  onClick={() => ModulesAction.changeSateItem('updateTime')}>
                                <span className={css.name}>更新时间</span>
                                <Icon type="shaixuanzhankai" className={css.img} />
                            </div>
                            <FormItem
                                {...formItemLayout}
                                className={searchActive === 'updateTime' ? '' : 'hide'}
                            >
                                <Col span={10}>
                                    <FormItem>
                                        {getFieldDecorator('lastModifyTimeBegin',{
                                            initialValue: filterList.lastModifyTimeBegin && moment(filterList.lastModifyTimeBegin, dateFormat)
                                        })(
                                            <DatePicker 
                                                style={{ width: '100%' }} 
                                                format={dateFormat}
                                                disabledDate={this.disabledStartDate}
                                                onChange={this.onStartChange} 
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                        至
                                    </span>
                                </Col>
                                <Col span={10}>
                                    <FormItem>
                                        {getFieldDecorator('lastModifyTimeEnd', {
                                            initialValue: filterList.lastModifyTimeEnd && moment(filterList.lastModifyTimeEnd, dateFormat)
                                        })(
                                            <DatePicker 
                                                style={{ width: '100%' }} 
                                                format={dateFormat} 
                                                disabledDate={this.disabledEndDate}
                                                onChange={this.onEndChange}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                            <div className={this.getItemClass('isArchived')} onClick={() => ModulesAction.changeSateItem('isArchived')}>
                                <span className={css.name}>存档状态</span>
                                <Icon type="shaixuanzhankai" className={css.img} />
                            </div>
                            <FormItem
                                {...formItemLayout}
                                className={searchActive === 'isArchived' ? '' : 'hide'}
                            >
                                {getFieldDecorator('isArchived', {
                                    initialValue: filterList.isArchived,
                                    rules: [],
                                })(
                                    <RadioGroup>
                                        <Radio value={false}>未存档</Radio>
                                        <Radio value={true}>已存档</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </div>
                        <div className={css.searchFooter}>
                            <Button onClick={this.handleSubmit} className='kts-but-general'>筛选</Button>
                            <Button onClick={this.restForm} className='kts-but-default'>清空</Button>
                        </div>
                    </Form>
                </div>
                
            </div>
        );
    }
    /** 
     * 清空 
     */
    private restForm = (e) => {
        ModulesAction.restSearch();
        this.startValue = undefined;
        this.endValue = undefined;
        this.issuestartValue = undefined;
        this.issueendValue = undefined;
        this.props.form.resetFields();
    }
    /**
     * 提交
     */
    private handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let date = {
                    ...values,
                    issueDateBegin: values.issueDateBegin && values.issueDateBegin.format('YYYY/MM/DD'),
                    issueDateEnd: values.issueDateEnd && values.issueDateEnd.format('YYYY/MM/DD'),
                    lastModifyTimeBegin: values.lastModifyTimeBegin && values.lastModifyTimeBegin.format('YYYY/MM/DD'),
                    lastModifyTimeEnd: values.lastModifyTimeEnd && values.lastModifyTimeEnd.format('YYYY/MM/DD'),
                };
                ModulesAction.saveFilter(date);
            }
        });
    }
    /**
     * 获取当前item 高亮
     */
    private getItemClass = (name: string) => {
        return (this.modulesState.searchActive === name ? `${css.item} ${css.itemActive}` : css.item); 
    }
    // 更新时间
    /** 开始时间限制 */
    private disabledStartDate = (startValue) => {
        const endValue = this.props.form.getFieldValue("lastModifyTimeEnd");
        if (!startValue || !endValue) {
            return false;
        }
        let endDate: any = new Date(endValue.format('YYYY/MM/DD'));
        let startDate: any = new Date(startValue.format('YYYY/MM/DD'));
        return Math.floor((endDate - startDate) / 86400000) < 0;
    }
    /**
     * 结束时间限制
     */
    private disabledEndDate = (endValue) => {
        const startValue = this.props.form.getFieldValue("lastModifyTimeBegin");
        if (!endValue || !startValue) {
            return false;
        }
        let endDate: any = new Date(endValue.format('YYYY/MM/DD'));
        let startDate: any = new Date(startValue.format('YYYY/MM/DD'));
        return Math.floor((endDate - startDate) / 86400000) < 0;
    }
    /** 起始时间改变 */
    private onStartChange = (value) => {
        this.startValue = value;
    }
    /** 结束时间改变 */
    private onEndChange = (value) => {
        this.endValue = value;
    }
    // 填报时间
    /** 开始时间限制 */
    private issuedisabledStartDate = (startValue) => {
        const endValue = this.props.form.getFieldValue("issueDateEnd"); 
        if (!startValue || !endValue) {
            return false;
        }
        let endDate: any = new Date(endValue.format('YYYY/MM/DD'));
        let startDate: any = new Date(startValue.format('YYYY/MM/DD'));
        return Math.floor((endDate - startDate) / 86400000) < 0;
    }
    /**
     * 结束时间限制
     */
    private issuedisabledEndDate = (endValue) => {
        const startValue = this.props.form.getFieldValue("issueDateBegin");
        if (!endValue || !startValue) {
            return false;
        }
        let endDate: any = new Date(endValue.format('YYYY/MM/DD'));
        let startDate: any = new Date(startValue.format('YYYY/MM/DD'));
        return Math.floor((endDate - startDate) / 86400000) < 0;
    }
    /** 起始时间改变 */
    private issueonStartChange = (value) => {
        this.issuestartValue = value;
    }
    /** 结束时间改变 */
    private issueonEndChange = (value) => {
        this.issueendValue = value;
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentList/UI.SearchDetail.tsx